import React, { useEffect, useState } from 'react';
import './styles';
import { useSelector } from 'react-redux';
import PLTable from '../../../../../components/PL/PLTable/PLTable';
import { SERVICES_TABLE_TYPE } from '../../../../../components/PL/PLTable/config';
import { GET_LISTING_SERVICES } from './queries';
import { useLocation } from 'react-router-dom';
import { getPaginatedTableVariablesByTypeAndSearchTypeScript } from '../../../../../components/PL/PLTable/TypeScriptHelpers';
import { useLazyQuery } from '@apollo/react-hooks';
import { getFiltersProp, getIsUserAdminSelector, getSignedInUserSelector } from '../../../../../redux/selectors/CurrentUserSelectors';
import * as strings from './strings';
import PLFilters from '../../../../../components/PL/PLFilters';
import { PLFILTER_TYPE_SERVICE } from '../../../../../components/PL/PLFilters/config';
import { USER_ROLE_AGENT, USER_ROLE_PHOTOGRAPHER } from '../../../../../utils/Config/Constants';
import UIBookingButton from '../../../../../components/UI/UIBookingButton';

export default function ListingServices({ listing }: ListingServicesProps) {
	const filters = useSelector(getFiltersProp);
	const isUserAdmin = useSelector(getIsUserAdminSelector);
	const signedInUser = useSelector(getSignedInUserSelector);

	const location = useLocation();

	let props = {
		filters,
		location
	};

	const [services, setServices] = useState<object[]>();
	const [refreshToken, setRefreshToken] = useState(0);

	const baseVariables = { query: { listingId: { op_eq: listing?.id } } };

	let variables = getPaginatedTableVariablesByTypeAndSearchTypeScript(20, SERVICES_TABLE_TYPE, props, baseVariables);
	const [getServices, { data: servicesData }] = useLazyQuery(GET_LISTING_SERVICES, { variables });

	useEffect(() => {
		(async () => {
			await getServices();
		})();
	}, []);

	useEffect(() => {
		(async () => {
			if (servicesData) {
				setServices(servicesData['services']);
			}
		})();
	}, [servicesData]);

	useEffect(() => {
		(async () => {
			await getServices();
		})();
	}, [refreshToken]);

	if (!services || !listing) return null;

	const renderOrderButton = () => {
		if (isUserAdmin || signedInUser.role === USER_ROLE_AGENT || signedInUser.role === USER_ROLE_PHOTOGRAPHER) {
			return (
				<UIBookingButton
					bookingClient={listing.client}
					listing={listing}
					onFinishBooking={() => setRefreshToken((prev) => prev + 1)}
					title={'order services'}
				/>
			);
		}

		return null;
	};

	return (
		<div className='listingServices'>
			<div className='general-header-pin'>
				<PLFilters type={PLFILTER_TYPE_SERVICE} updateTable={getServices} />
				<div style={{ marginLeft: 12, marginRight: 12, width: 1, height: 24, backgroundColor: '#f1f1f14c' }} />
				{renderOrderButton()}
			</div>
			<PLTable type={SERVICES_TABLE_TYPE} limit={20} updateTable={getServices} data={services} emptySetText={strings.emptySet} hideAddress={true} />
		</div>
	);
}
